var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,22c-16.6,0-30,12.5-30,28c0,5,1.4,9.6,3.8,13.7c0.3,0.5,0.4,1.1,0.2,1.6l-2.8,8.9c-0.5,1.6,1,3,2.6,2.5 l8.8-3.1c0.6-0.2,1.2-0.1,1.7,0.2c4.6,2.7,10,4.2,15.8,4.2c16.6,0,30-12.5,30-28C80,34.5,66.6,22,50,22z M53,67c0,1.1-0.9,2-2,2h-2 c-1.1,0-2-0.9-2-2v-2c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2V67z M53.8,54.3c-0.4,0.1-0.8,0.5-0.8,1v1.6c0,1.1-0.9,2.1-2,2.1h-2 c-1.1,0-2-1-2-2.1v-1.6c0-3,2-5.7,4.9-6.7c1.1-0.4,2.1-0.9,2.7-1.8c3.4-4.5,0-9.7-4.5-9.8c-1.6-0.1-3.2,0.6-4.4,1.7 c-0.8,0.8-1.4,1.8-1.6,2.8c-0.2,0.9-1,1.6-1.9,1.6h-2.1c-1.2,0-2.2-1.2-2-2.4c0.5-2.4,1.6-4.6,3.4-6.3c2.3-2.3,5.4-3.5,8.7-3.4 c6.3,0.2,11.5,5.4,11.7,11.7C62.1,47.9,58.9,52.6,53.8,54.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.cf8b40af9179deaa0e5133b937a8176f.svg";
export { ForwardRef as ReactComponent };